$(document).ready(function () {
  //check for the header to see if it is scrolling
  
  window.addEventListener("scroll", () => {
    document
      .querySelector("header")
      .classList.toggle("scrolling", window.scrollY > 20);
  });

  //home feed swapper 
  $('#home-product-feed .button-nav .button').click(function(){
      let el = $(this).attr('id');
      el = '#' + el + '-feed';

      $('#home-product-feed .button-nav .button').removeClass('active');
      $(this).addClass('active');
      
      $('#home-feed-title').text($(this).text());

      $('#home-product-feed').find('.home-product-feed').removeClass('active');
     
      $(el).addClass('active');
  })
  

  $('.recipe-filter-buttons span').click(function(){
    var el = $(this).data('recipe-filter');

    $('.recipe-filter-buttons span').removeClass('active');
    $(this).addClass('active');

    $('#recipe-roll .recipe-card').removeClass('active');

     if(el == "all"){
        $('#recipe-roll .recipe-card').addClass('active');
    } else {
      $('#recipe-roll .recipe-card').each(function(){
        let elCat = $(this).data('category');
        if(elCat == el){
          $(this).addClass('active');
        }
      });
    }
  })
  

  //ticker
  function buildTicker(trackEl, items) {
    // Build one set of items
    function renderSet() {
      return items.map((text) => {
        const span = document.createElement("span");
        span.className = "ticker-item";
        span.innerHTML = `<span class="dot"></span>${text}`;
        return span;
      });
    }

    // Duplicate the set so the CSS 50% translate creates a seamless loop
    const setA = renderSet();
    const setB = renderSet();
    [...setA, ...setB].forEach((el) => trackEl.appendChild(el));
  }

  // ── Data ──────────────────────────────────────────────────────────────

  const tickerData = {
    track1: [
      "FROM OUR HERATIGE TO YOU PLATE",
      "AUTHENTIC FLAVOR IN EVERY BITE... WE WON'T TELL YOUR ABUELA!",
      "ROOTE IN MEXICO, MADE IN TEXAS",
      "CATCH WHAT IS COOKING ON OUR FEED",
    ],
  };

  Object.entries(tickerData).forEach(([id, items]) => {
    const track = document.getElementById(id);
    if (track) buildTicker(track, items);
  });

  $("#main-nav a").on("mouseenter", function () {
    var target = $(this).data("nav-link");
    $(".mega-nav-drop").removeClass("is-open");
    $("#" + target).addClass("is-open");
  });

  $(".mega-nav-drop").on("mouseleave", function () {
    $(this).removeClass("is-open");
  });


  $('#side-bar-links a').hover(function(){
      let el = $(this).data('id');
      $('.mega-nav-item-block').removeClass('active');
      $('#' + el).addClass('active');
  })

  //slider
  $(".slider-collection-feed").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".sold-in-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
  });

  $(".slider-product-feed").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //slider
  $(".home-social-feed").slick({
    dots: true,
    infinite: false,
    arrows: true,
    center: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //slider
  $(".home-recipe-feed").slick({
    dots: false,
    infinite: false,
    arrows: true,
    centerMode: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  
  var $slider = $(".home-slider-wrapper").slick({
    dots: true,
    infinite: true,
    arrows: true,
    fade: true,
    autoplay: true, 
    pauseOnHover: false,  
    speed: 700,
    slidesToShow: 1,
    autoplaySpeed: 7000,   
    slidesToScroll: 1,
});

$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.slick-active').first().find('.hero-content').removeClass('active');
});

$slider.on('afterChange', function(event, slick, currentSlide) {
   $('.slick-active').first().find('.hero-content').addClass('active');
});

  // Select elements you want to set as waypoints
  $(".home-sold-in-image").each(function () {
    let $el = $(this);
    $el.waypoint({
      handler: function (direction) {
        // 'direction' is either 'down' or 'up'
        console.log(
          `${$el.attr("id")} waypoint triggered, scrolling ${direction}`,
        );

        $('#flourish-bg-1').addClass('active');
        $('#flourish-bg-2').addClass('active');
        $('#flourish-bg-3').addClass('active');
        $('#flourish-bg-4').addClass('active');
      },
      // Trigger waypoint when element is 10% from top of viewport
      offset: "120%",
    });
  });

document.querySelectorAll('.acc-head').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var row = document.getElementById(btn.dataset.target);
    var body = row.querySelector('.acc-body');
    var isOpen = row.classList.contains('open');
    document.querySelectorAll('.acc-row.open').forEach(function(r) {
      r.classList.remove('open');
      r.querySelector('.acc-body').style.maxHeight = '0';
      r.querySelector('.acc-head').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      row.classList.add('open');
      body.style.maxHeight = body.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});
});


